export default __webpack_public_path__ + "static/media/UHD_PRO_CEC.2717321c.png";